import React from 'react';
import IconImg from '../../images/mobile.svg';

const FeaturesSection = () => {
  const defaultCards = [
    {
      imageSrc: <IconImg className="w-6 h-6 text-purple-700" />,
      title: 'SPA',
      description:
        'We strictly only deal with vendors that provide top notch security.',
    },
    {
      imageSrc: <IconImg className="w-6 h-6 text-purple-700" />,
      title: 'Offline',
    },
    {
      imageSrc: <IconImg className="w-6 h-6 text-purple-700" />,
      title: 'Optimized images',
    },
    {
      imageSrc: <IconImg className="w-6 h-6 text-purple-700" />,
      title: 'Responsive',
    },
    {
      imageSrc: <IconImg className="w-6 h-6 text-purple-700" />,
      title: 'Fast',
    },
    {
      imageSrc: <IconImg className="w-6 h-6 text-purple-700" />,
      title: 'SEO',
    },
  ];

  return (
    <section>
      <div className="flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-xl mx-auto px-5 py-20 md:py-24 ">
        <h5 className="font-bold text-primary-purple mb-4">FEATURES</h5>

        <h2 className="text-4xl sm:text-5xl font-black tracking-wide text-center w-full">
          We have Amazing <span className="text-primary-purple">Service.</span>
        </h2>

        <p className="mt-4 text-sm md:text-base lg:text-lg font-medium leading-relaxed text-gray-700 max-w-xl w-full text-center">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Ad, libero.
        </p>

        <div className="mt-10 w-full" />

        {defaultCards.map((card, i) => (
          <div className="md:w-1/2 lg:w-1/3 max-w-sm" key={i}>
            <div className="flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left h-full mx-4 px-2 py-8">
              <span className="border text-center rounded-full shadow-lg p-5 flex-shrink-0">
                {card.imageSrc}
              </span>
              <span className="sm:ml-4 mt-4 sm:mt-2">
                <span className="mt-4 tracking-wide font-bold text-2xl text-primary-purple leading-none">
                  {card.title || 'Fully Secure'}
                </span>
                <p className="mt-1 sm:mt-4 font-medium text-gray-700 leading-loose">
                  {card.description ||
                    'Lorem ipsum donor amet siti ceali ut enim ad minim veniam, quis nostrud.'}
                </p>
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturesSection;
